module.exports = __webpack_public_path__ + "img/4.dabc2429.png";